import { TNewOrderCountry } from "@/entities/new-order";

//возвращает массив ключей из первого дня объекта keywords у страны
export const getKeysFromCountry = (country: TNewOrderCountry): string[] => {
  if (!country?.keywords || typeof country.keywords !== "object") {
    return [];
  }

  const dates = Object.keys(country.keywords);
  if (dates.length === 0) {
    return [];
  }

  const firstDate = dates[0];
  const firstDateKeywords = country.keywords[firstDate];

  if (!firstDateKeywords || typeof firstDateKeywords !== "object") {
    return [];
  }

  return Object.keys(firstDateKeywords);
};
